export function preventTimeZone(dateString) {
    if (!dateString) {
        return dateString;
    }
    const [year, month, day] = dateString.split("-").map((num) => parseInt(num, 10));
    const dateObject = new Date(year, month - 1, day); // Create a Date object without time zone conversion
    return dateObject.toLocaleDateString();
}
export function preventTimeZoneLang(dateString) {
    if (!dateString) {
        return dateString;
    }
    const [year, month, day] = dateString.split("-").map((num) => parseInt(num, 10));
    const dateObject = new Date(year, month - 1, day); // Create a Date object without time zone conversion
    return dateObject.toLocaleDateString("default", {
        year: "numeric",
        month: "long",
        day: "numeric",
    });
}

export function preventTimeZoneShort(dateString) {
    if (!dateString) {
        return dateString;
    }
    const [year, month, day] = dateString.split("-").map((num) => parseInt(num, 10));
    const dateObject = new Date(year, month - 1, day); // Create a Date object without time zone conversion
    return dateObject.toLocaleString("default", {
        month: "long",
        year: "numeric",
    });
}

export function preventTimeZoneDate(dateInput) {
    if (!dateInput) {
        return null;
    }

    if (dateInput instanceof Date) {
        // Extract the local date components from the input Date object
        const year = dateInput.getFullYear();
        const month = dateInput.getMonth(); // Month is 0-indexed
        const day = dateInput.getDate();

        // Construct a new Date object using the local date components
        const dateObject = new Date(year, month, day);
        return dateObject;
    }

    const [year, month, day] = dateInput.split("-").map((num) => parseInt(num, 10));
    const dateObject = new Date(year, month - 1, day); // Create a Date object without time zone conversion
    return dateObject;
}

export function customISODateString(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed, add 1 to get the correct month
    const day = date.getDate().toString().padStart(2, "0");

    return `${year}-${month}-${day}`;
}

export function preventTimeZone2(dateString) {
    if (!dateString) {
        return dateString;
    }
    const [year, month, day] = dateString.split("-").map((num) => parseInt(num, 10));
    const dateObject = new Date(Date.UTC(year, month - 1, day)); // Ensure the date is in UTC

    // Return in "YYYY-MM-DD" format
    const formattedDate = `${dateObject.getUTCFullYear()}-${String(dateObject.getUTCMonth() + 1).padStart(
        2,
        "0"
    )}-${String(dateObject.getUTCDate()).padStart(2, "0")}`;

    return formattedDate;
}
